import React from "react";

/**
 * Cyber Repair Corp official emblem
 * Faithful vector reconstruction of the business-card badge:
 *  · Black circular base
 *  · Silver pentagonal shield with a V-notch on top
 *  · Grey "R" letter centered inside the shield
 *  · Small screwdriver poking out at the bottom-left
 */
export default function Logo({ size = 40, variant = "dark", showRing = true }) {
  // variant "dark"  -> for light backgrounds (black disc, silver shield)
  // variant "light" -> for dark backgrounds (transparent disc outline, silver shield)
  const disc = variant === "light" ? "transparent" : "#0B0708";
  const discStroke = variant === "light" ? "#C7B9BA" : "#1A1214";
  const shieldGrad1 = "#EAE3E4";
  const shieldGrad2 = "#8E8688";
  const letter = "#5A5254";
  const tool = "#DAD3D4";
  const toolTip = "#B01B27";

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Cyber Repair Corp"
    >
      <defs>
        <linearGradient id="shieldGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={shieldGrad1} />
          <stop offset="55%" stopColor="#B8AFB0" />
          <stop offset="100%" stopColor={shieldGrad2} />
        </linearGradient>
        <linearGradient id="shieldInner" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F5EFEF" />
          <stop offset="100%" stopColor="#9E9698" />
        </linearGradient>
      </defs>

      {/* Circular disc */}
      {showRing && (
        <circle
          cx="50"
          cy="50"
          r="48"
          fill={disc}
          stroke={discStroke}
          strokeWidth="1.5"
        />
      )}

      {/* Screwdriver poking out bottom-left */}
      <g>
        <rect x="16" y="72" width="18" height="4.2" rx="1" transform="rotate(45 25 74)" fill={tool} />
        <rect x="30" y="72" width="8" height="4.2" rx="0.6" transform="rotate(45 34 74)" fill={toolTip} />
      </g>

      {/* Pentagonal shield with V-notch on top */}
      <path
        d="M 24 22 L 40 32 L 50 26 L 60 32 L 76 22 L 76 58 L 50 82 L 24 58 Z"
        fill="url(#shieldGrad)"
        stroke="#5F5658"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      {/* Inner shield to give depth */}
      <path
        d="M 30 27 L 41 34 L 50 30 L 59 34 L 70 27 L 70 55 L 50 76 L 30 55 Z"
        fill="url(#shieldInner)"
        opacity="0.55"
      />

      {/* R letter */}
      <text
        x="50"
        y="60"
        fontFamily='"Cabinet Grotesk", "IBM Plex Sans", sans-serif'
        fontWeight="800"
        fontSize="34"
        fill={letter}
        textAnchor="middle"
        letterSpacing="-1"
      >
        R
      </text>
    </svg>
  );
}
